var map = {
	"./84_contentMultiple-REGULAR.svg": "FV11",
	"./admira-cloud.png": "7oB/",
	"./admira-logo_s_white.png": "L4oL",
	"./admiralogo.png": "O2gp",
	"./fonts/Admira-Font-Outline-34.ttf": "T828",
	"./fonts/Roboto-Medium.ttf": "BEBZ",
	"./logo.png": "7Otq",
	"./logo.svg": "AqYs",
	"./popup.png": "wROS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1